import React from "react";
import { useSelector } from "react-redux";
import { Title, RowContainer } from "./styled";
import { Avatar } from "@mui/material";

const FiscaisFeature = (props) => {
  const card = useSelector((state) => state.card); 

  const getInitials = (name) => {
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <>
      <Title>Fiscais</Title>
      <RowContainer>
        {card.fiscais.map((fiscal, index) => {
          return (
            <Avatar
              key={index}
              sx={{
                width: 32,
                height: 32,
                bgcolor: fiscal.color,
                fontSize: "0.875rem",
                fontWeight: "800",
              }}
            >
              {getInitials(fiscal.name)}
            </Avatar>
          );
        })}        
      </RowContainer>      
    </>
  );
};

export default FiscaisFeature;
